import { Button } from "@/components/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
  DialogHeader,
} from "@/components/dialog";
import { Modal } from "@/components/modal";

type DeleteNoteModalProps = {
  isDeleting: boolean;
  isOpen: boolean;
  onConfirm: () => void;
  onOpenChange: (isOpen: boolean) => void;
};

export function DeleteNoteModal({
  isDeleting,
  isOpen,
  onConfirm,
  onOpenChange,
}: DeleteNoteModalProps) {
  return (
    <Modal isDismissable isOpen={isOpen} onOpenChange={onOpenChange}>
      <Dialog>
        <DialogCloseButton />
        <DialogHeader>Delete note</DialogHeader>
        <DialogBody>
          <p className="text-sm text-text-secondary">
            Are you sure you want to delete this note? This action cannot be
            undone.
          </p>
        </DialogBody>
        <DialogFooter>
          <Button
            color="gray"
            onPress={() => onOpenChange(false)}
            type="button"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            color="destructive"
            isDisabled={isDeleting}
            isLoading={isDeleting}
            onPress={onConfirm}
            type="button"
            variant="primary"
          >
            Delete
          </Button>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
